import { BarChart as MUIBarChart } from '@mui/x-charts/BarChart'
import { color } from 'config/color'

interface BarChartProps {
  seriesData: number[]
  xAxisData: string[]
  valueFormatter: (value: number | string | null) => string
}

export const BarChart: React.FC<BarChartProps> = (props: BarChartProps) => {
  return (
    <MUIBarChart
      series={[
        {
          color: color.secondary.dark[200],
          data: props.seriesData,
          valueFormatter: props.valueFormatter
        }
      ]}
      height={476}
      xAxis={[{ data: props.xAxisData, scaleType: 'band' }]}
      grid={{ horizontal: true }}
      tooltip={{ trigger: 'axis' }}
      axisHighlight={{
        x: 'none'
      }}
      sx={sx}
    />
  )
}

const sx = {
  '& .MuiChartsAxis-left .MuiChartsAxis-tick': {
    stroke: color.white
  },
  '& .MuiChartsAxis-left .MuiChartsAxis-line': {
    stroke: color.white
  },
  '& .MuiChartsAxis-left .MuiChartsAxis-tickLabel': {
    fill: color.grey[700]
  },
  '.MuiChartsAxis-bottom .MuiChartsAxis-tick': {
    stroke: color.secondary.dark[300]
  },
  '& .MuiChartsAxis-bottom .MuiChartsAxis-line': {
    stroke: color.secondary.dark[300]
  },
  '& .MuiChartsGrid-line ': {
    stroke: color.secondary.dark[300],
    shapeRendering: 'auto !important'
  },
  '& .MuiBarElement-root:hover': {
    fill: color.primary[600]
  }
}
